import classNames from 'classnames/bind';
import styles from './PaidAndLeftReview.module.scss';
import TableClassicReport from '../base/TableClassicReport';
import { useEffect, useState } from 'react';
import { IPaginationReport, IPaidAndLeftReviewRecord } from '~/utils/interface/report';
import reportApi from '~/apis/report';
import { ColumnType } from '~/utils/types/common';
import dayjs from 'dayjs';

const cx = classNames.bind(styles);

const RECORD_STATUS = [
  { label: 'Paid & Left Review', value: 'PAID_N_LEFT_REVIEW' },
]

const PaidAndLeftReview = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IPaidAndLeftReviewRecord[]>([]);
  const [pagination, setPagination] = useState<IPaginationReport>({
    totalItems: 0,
    totalPage: 0,
    page: 1,
    limit: 10,
    skip: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await reportApi.getPaidAndLeftReview({ page: pagination.page });
        setData(response.data?.data?.responses ?? []);
        setPagination(response.data?.data?.pagination ?? {
          totalItems: 0,
          totalPage: 0,
          page: 1,
          limit: 10,
          skip: 0,
        });
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch paid and left review', error);
        setLoading(false);
      }
    };
    fetchData();
  }, [pagination.page]);


  const columns: Array<ColumnType> = [
    {
      id: "salesRep",
      labelHeader: "Sales Rep",
      renderCell: (paidAndLeftReview: IPaidAndLeftReviewRecord) => (
        <div
          className={cx("cell")}
        >
          <p className={cx("text-content")}>{paidAndLeftReview.saleRep.name || "-"}</p>
        </div>
      ),
    },
    {
      id: "primaryContact",
      labelHeader: "Primary Contact",
      renderCell: (paidAndLeftReview: IPaidAndLeftReviewRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{paidAndLeftReview.primaryContact.name || "-"}</p>
        </div>
      ),
    },
    {
      id: "addressLine",
      labelHeader: "Address Line",
      renderCell: (paidAndLeftReview: IPaidAndLeftReviewRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{paidAndLeftReview.addressLine || "-"}</p>
        </div>
      ),
    },
    {
      id: "city",
      labelHeader: "City",
      renderCell: (paidAndLeftReview: IPaidAndLeftReviewRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{paidAndLeftReview.city || "-"}</p>
        </div>
      ),
    },
    {
      id: "zip",
      labelHeader: "Zip",
      renderCell: (paidAndLeftReview: IPaidAndLeftReviewRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{paidAndLeftReview.zip || "-"}</p>
        </div>
      ),
    },
    {
      id: "state",
      labelHeader: "State",
      renderCell: (paidAndLeftReview: IPaidAndLeftReviewRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{paidAndLeftReview.state || "-"}</p>
        </div>
      ),
    },
    {
      id: "type",
      labelHeader: "Type",
      renderCell: (paidAndLeftReview: IPaidAndLeftReviewRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{paidAndLeftReview.recordType || "-"}</p>
        </div>
      ),
    },
    {
      id: "status",
      labelHeader: "Status",
      renderCell: (paidAndLeftReview: IPaidAndLeftReviewRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{RECORD_STATUS.find(item => item.value === paidAndLeftReview.status)?.label || "-"}</p>
        </div>
      ),
    },
    {
      id: "dateStatusChanges",
      labelHeader: "Date Status Changes",
      renderCell: (paidAndLeftReview: IPaidAndLeftReviewRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{dayjs(paidAndLeftReview.dateStatusChanges).format("MM/DD/YYYY hh:mm A") || "-"}</p>
        </div>
      ),
    },
  ];

  return (
    <TableClassicReport
      title="Paid & Left Review"
      columns={columns}
      data={data}
      page={pagination.page}
      totalPages={pagination.totalPage}
      totalItems={pagination.totalItems}
      itemsPerPage={pagination.limit}
      onPageChange={(page) => {
        setPagination({ ...pagination, page });
      }}
      isLoading={loading}
    />
  );
};

export default PaidAndLeftReview;
